import UserSettingsContainer from './UserSettings';

export default UserSettingsContainer;
